// extracted by mini-css-extract-plugin
export default {"certificates":"ListCertificate_certificates__5oDJP","certificatesTitle":"ListCertificate_certificatesTitle__6PfsS","certificatesList":"ListCertificate_certificatesList__utUYg"};